import { Button, CopyField } from './components';

/**
 * Development only: the API sends the current second-factor code (`MFA_DEV_CODES`), so no
 * authenticator app is needed. Renders nothing when the API did not send one, which is always
 * the case in staging and production.
 */
export function DevCode({
  code,
  onUse,
  label,
  useLabel,
}: {
  code: string | undefined;
  onUse: (code: string) => void;
  label: string;
  useLabel: string;
}) {
  if (code === undefined) return null;
  return (
    <div
      role="note"
      className="flex items-center justify-between gap-3 rounded-md bg-amber-50 p-3 text-sm text-amber-900 ring-1 ring-amber-200"
    >
      <span>
        {label}{' '}
        <strong className="ltr font-mono text-base" data-testid="dev-code">
          {code}
        </strong>
      </span>
      <Button
        tone="secondary"
        onClick={() => {
          onUse(code);
        }}
      >
        {useLabel}
      </Button>
    </div>
  );
}

/** Recovery codes, shown once: a grid to read and a single field to copy them all. */
export function RecoveryCodes({ codes, label }: { codes: readonly string[]; label: string }) {
  return (
    <div className="flex flex-col gap-3">
      <ul className="ltr grid grid-cols-2 gap-2 font-mono text-sm" data-testid="recovery-codes">
        {codes.map((code) => (
          <li key={code} className="rounded bg-slate-100 px-2 py-1 text-center">
            {code}
          </li>
        ))}
      </ul>
      <CopyField label={label} value={codes.join(' ')} />
    </div>
  );
}
